/**
 * Nuo Networks - Automatic EPCOM Photo Resolver
 * Dynamically resolves and renders official EPCOM product photographs on storefront cards
 * whenever Shopify media has not yet synced, eliminating "Hardware Photo Updating" placeholders.
 */

(function() {
  function resolveMissingImages() {
    if (!window.EPCOM_IMAGES_MAP) return;

    // 1. Resolve Product Cards in Collections / Search / Grids
    const targets = document.querySelectorAll('.ne-epcom-img-target[data-epcom-sku]:not([data-epcom-resolved])');
    targets.forEach(target => {
      target.setAttribute('data-epcom-resolved', 'true');
      const rawSku = (target.getAttribute('data-epcom-sku') || '').trim();
      const cleanSku = rawSku.toUpperCase().replace(/[^A-Z0-9]/g, '');
      const title = target.getAttribute('data-epcom-title') || 'Hardware Image';

      const imgUrl = window.EPCOM_IMAGES_MAP[cleanSku] || window.EPCOM_IMAGES_MAP[rawSku.toUpperCase()];
      if (imgUrl) {
        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = title;
        img.loading = 'lazy';
        img.className = 'motion-reduce ne-epcom-recovered-img';
        img.style.cssText = 'width: 100%; height: 100%; object-fit: contain; max-height: 100%; max-width: 100%; position: absolute; inset: 0; padding: 10px; box-sizing: border-box; transition: opacity 0.3s ease, transform 0.3s ease; opacity: 0; background: #ffffff;';

        img.onload = function() {
          img.style.opacity = '1';
          const fallback = target.querySelector('.ne-placeholder-fallback');
          if (fallback) fallback.style.display = 'none';
        };

        img.onerror = function() {
          img.remove();
          // Directriz Nuo: si no tiene foto, no lo muestres en tienda
          const cardItem = target.closest('.grid__item, .ne-grid-item, li.grid__item');
          if (cardItem) cardItem.style.display = 'none';
        };

        target.appendChild(img);
      } else {
        // Directriz Nuo: si no tiene foto cotejada, ocultar tarjeta de inmediato
        const cardItem = target.closest('.grid__item, .ne-grid-item, li.grid__item');
        if (cardItem) cardItem.style.display = 'none';
      }
    });

    // 2. Resolve Product Details Page (PDP) Main Gallery Image
    const pdpImgWrapper = document.querySelector('.ne-pdp-main-image-wrapper');
    const pdpSkuEl = document.getElementById('NePdpSku');
    if (pdpImgWrapper && pdpSkuEl) {
      const placeholderSvg = pdpImgWrapper.querySelector('svg');
      if (placeholderSvg) {
        const pdpSku = pdpSkuEl.textContent.trim();
        const cleanPdpSku = pdpSku.toUpperCase().replace(/[^A-Z0-9]/g, '');
        const imgUrl = window.EPCOM_IMAGES_MAP[cleanPdpSku] || window.EPCOM_IMAGES_MAP[pdpSku.toUpperCase()];
        if (imgUrl) {
          placeholderSvg.remove();
          const newImg = document.createElement('img');
          newImg.id = 'NeMainProductImage';
          newImg.src = imgUrl;
          newImg.alt = pdpSku;
          newImg.width = 800;
          newImg.height = 800;
          newImg.style.cssText = 'max-width: 100%; max-height: 100%; object-fit: contain; width: auto; height: auto;';
          pdpImgWrapper.appendChild(newImg);
        }
      }
    }
    // 3. Directriz Nuo: Ocultar inmediatamente tarjetas con precio 0 o $0.00
    document.querySelectorAll('.grid__item, .ne-grid-item, li.grid__item').forEach(item => {
      const priceText = item.querySelector('.price, .ne-card-price, .price__regular');
      if (priceText && (priceText.textContent.includes('$0.00') || priceText.textContent.trim() === '$0')) {
        item.style.display = 'none';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolveMissingImages);
  } else {
    resolveMissingImages();
  }

  // Debounced MutationObserver for dynamic filters / facet updates
  let timeoutId = null;
  const observer = new MutationObserver(function() {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(resolveMissingImages, 60);
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
